export type SidebarItem = {
  // without nested links
  title: string
  link?: string
  links?: SidebarItem[]
  icon?: Component
  active?: string[]
  dropdown?: boolean
}

// -------------------
// SIDEBAR LINKS
// -------------------

export const jobStudentSidebarLinks: SidebarItem[] = [
  {
    title: 'Browse Jobs',
    link: '/jobs/browse?page=1',
    icon: defineAsyncComponent(() => import('~/components/common/icon/jobs/IconNavFind.vue'))
  },
  {
    title: 'Saved Jobs',
    link: '/jobs/saved-jobs',
    icon: defineAsyncComponent(() => import('~/components/common/icon/jobs/IconNavSaved.vue'))
  },
  {
    title: 'Applied Jobs',
    link: '/jobs/applied-jobs',
    icon: defineAsyncComponent(() => import('~/components/common/icon/jobs/IconNavApply.vue'))
  }
]

export const programmesStudentSidebarLinks: SidebarItem[] = [
  {
    title: 'Find Programmes',
    link: '/programmes/student/find-programmes',
    icon: defineAsyncComponent(() => import('~/components/common/icon/jobs/IconNavFind.vue'))
  },
  {
    title: 'My Programmes',
    link: '/programmes/student/my-programmes',
    icon: defineAsyncComponent(() => import('~/components/common/icon/jobs/IconNavApply.vue'))
  }
]

export const studentForumSidebarLinks: SidebarItem[] = [
  {
    title: 'Feed',
    link: '/forum/feed',
    icon: defineAsyncComponent(
      () => import('~/components/common/icon/sidebar/forum/IconSidebarForumFeed.vue')
    )
  },
  {
    title: 'Browse tags',
    link: '/forum/tag/browse',
    icon: defineAsyncComponent(
      () => import('~/components/common/icon/sidebar/IconSidebarSearch.vue')
    )
  },
  {
    title: 'History',
    link: '/forum/history',
    icon: defineAsyncComponent(
      () => import('~/components/common/icon/sidebar/forum/IconSidebarForumHistory.vue')
    )
  },
  {
    title: 'Bookmarks',
    link: '/forum/bookmark',
    icon: defineAsyncComponent(
      () => import('~/components/common/icon/sidebar/forum/IconSidebarForumBookmark.vue')
    )
  }
]

export const adminForumSidebarLinks: SidebarItem[] = [
  {
    title: 'Dashboard',
    link: '/forum/admin/',
    icon: defineAsyncComponent(
      () => import('~/components/common/icon/sidebar/forum/IconSidebarForumFeed.vue')
    )
  },
  {
    title: 'Support',
    link: '/forum/support',
    icon: defineAsyncComponent(
      () => import('~/components/common/icon/sidebar/forum/IconSidebarForumSupport.vue')
    )
  },
  {
    title: 'Reports',
    link: '/forum/report/all',
    icon: defineAsyncComponent(
      () => import('~/components/common/icon/sidebar/forum/IconSidebarForumReport.vue')
    )
  },
  {
    title: 'History',
    link: '/forum/history',
    icon: defineAsyncComponent(
      () => import('~/components/common/icon/sidebar/forum/IconSidebarForumHistory.vue')
    )
  },
  {
    title: 'Bookmarks',
    link: '/forum/bookmark',
    icon: defineAsyncComponent(
      () => import('~/components/common/icon/sidebar/forum/IconSidebarForumBookmark.vue')
    )
  },
  {
    title: 'Browse tags',
    link: '/forum/tag/browse',
    icon: defineAsyncComponent(
      () => import('~/components/common/icon/sidebar/IconSidebarSearch.vue')
    )
  }
]

export const publicForumSidebarLinks: SidebarItem[] = [
  {
    title: 'Feed',
    link: '/forum/feed',
    icon: defineAsyncComponent(
      () => import('~/components/common/icon/sidebar/forum/IconSidebarForumFeed.vue')
    )
  },
  {
    title: 'Browse tags',
    link: '/forum/tag/browse',
    icon: defineAsyncComponent(
      () => import('~/components/common/icon/sidebar/IconSidebarSearch.vue')
    )
  }
]

const settings: SidebarItem = {
  title: 'Settings',
  link: '/settings',
  icon: defineAsyncComponent(
    () => import('~/components/common/icon/sidebar/IconSidebarSettings.vue')
  )
}

export const homeStudentSidebarLinks: SidebarItem[] = [
  {
    title: 'Dashboard',
    link: '/dashboard',
    icon: defineAsyncComponent(() => import('~/components/common/icon/sidebar/IconSidebarHome.vue'))
  },
  {
    title: 'CV',
    link: '/cv',
    icon: defineAsyncComponent(() => import('~/components/common/icon/sidebar/IconSidebarCV.vue'))
  },
  {
    title: 'Profile',
    link: '/profile',
    icon: defineAsyncComponent(
      () => import('~/components/common/icon/sidebar/IconSidebarProfile.vue')
    )
  },
  settings
]

export const learnStudentSidebarLinks: SidebarItem[] = [
  {
    title: 'My courses',
    link: '/courses/my-learning',
    icon: defineAsyncComponent(() => import('~/components/common/icon/sidebar/IconSidebarBook.vue'))
  },
  {
    title: 'My certificates',
    link: '/courses/certificates',
    icon: defineAsyncComponent(
      () => import('~/components/common/icon/sidebar/IconSidebarCertificates.vue')
    )
  },
  //   {
  //     title: 'Classroom',
  //     link: '/classroom',
  //     icon: defineAsyncComponent(() => import('~/components/common/icon/sidebar/IconSidebarBook.vue'))
  //   },
  {
    title: 'Browse courses',
    link: '/courses/browse',
    icon: defineAsyncComponent(
      () => import('~/components/common/icon/sidebar/IconSidebarSearch.vue')
    )
  },
  {
    title: 'Programmes',
    link: '/courses/programmes',
    icon: defineAsyncComponent(
      () => import('~/components/common/icon/sidebar/IconSidebarProgrammes.vue')
    )
  }
]

const browseJobs: SidebarItem = {
  title: 'Browse jobs',
  link: '/jobs/browse',
  icon: defineAsyncComponent(() => import('~/components/common/icon/sidebar/IconSidebarSearch.vue'))
}

export const jobsStudentSidebarLinks: SidebarItem[] = [
  browseJobs,
  {
    title: 'Saved jobs',
    link: '/jobs/saved-jobs',
    icon: defineAsyncComponent(
      () => import('~/components/common/icon/sidebar/forum/IconSidebarForumBookmark.vue')
    )
  },
  {
    title: 'Applied jobs',
    link: '/jobs/applied-jobs',
    icon: defineAsyncComponent(() => import('~/components/common/icon/sidebar/IconSidebarJobs.vue'))
  }
]

export const skillsStudentSidebarLinks: SidebarItem[] = [
  {
    title: 'Skills home',
    link: '/skills/home',
    icon: defineAsyncComponent(
      () => import('~/components/common/icon/sidebar/IconSidebarSearch.vue')
    )
  },
  {
    title: 'Applications',
    link: '/skills/tasks',
    icon: defineAsyncComponent(
      () => import('~/components/common/icon/sidebar/IconSidebarSearch.vue')
    )
  }
]

export const studentSidebarLinks = {
  home: homeStudentSidebarLinks,
  learn: learnStudentSidebarLinks,
  jobs: jobsStudentSidebarLinks,
  skills: skillsStudentSidebarLinks,
  forum: studentForumSidebarLinks,
  events: null
}

export const adminSidebarLinks = {
  home: [
    {
      title: 'Dashboard',
      link: '/dashboard/admin',
      icon: defineAsyncComponent(
        () => import('~/components/common/icon/sidebar/IconSidebarHome.vue')
      )
    },
    settings
  ],
  jobs: [browseJobs],
  skills: [
    {
      title: 'Assessments',
      link: '/skills/admin/assessments',
      icon: defineAsyncComponent(
        () => import('~/components/common/icon/sidebar/IconSidebarProfile.vue')
      )
    },
    {
      title: 'Interviews',
      link: '/skills/admin',
      icon: defineAsyncComponent(() => import('~/components/common/icon/interviews/IconCam.vue'))
    }
  ],
  events: null
}

// -------------------
// NAVBAR LINKS
// -------------------

const jobLinkItem: SidebarItem = {
  title: 'Jobs',
  icon: defineAsyncComponent(() => import('~/components/common/icon/sidebar/IconSidebarJobs.vue')),
  link: '/jobs/browse',
  active: ['jobs'],
  dropdown: true
}

const eventsLinkItem: SidebarItem = {
  title: 'Events',
  icon: defineAsyncComponent(
    () => import('~/components/common/icon/sidebar/IconSidebarCalendar.vue')
  ),
  link: '/events',
  active: ['events'],
  dropdown: false
}

const forumLinkItem: SidebarItem = {
  title: 'Forum',
  icon: defineAsyncComponent(
    () => import('~/components/common/icon/sidebar/forum/IconSidebarForumFeed.vue')
  ),
  link: '/forum/feed',
  active: ['forum'],
  dropdown: true
}

export type StudentNavbarTitle = 'home' | 'learn' | 'jobs' | 'forum' | 'events' | 'skills'
export type AdminNavbarTitle = 'home' | 'jobs' | 'events' | 'skills'

export const studentNavbarLinks: SidebarItem[] = [
  {
    title: 'Home',
    icon: defineAsyncComponent(
      () => import('~/components/common/icon/sidebar/IconSidebarHome.vue')
    ),
    link: '/dashboard',
    active: ['dashboard', 'profile', 'settings', 'cv'],
    dropdown: false
  },
  {
    title: 'Learn',
    icon: defineAsyncComponent(
      () => import('~/components/common/icon/sidebar/IconSidebarBook.vue')
    ),
    link: '/courses/my-learning',
    active: ['courses', 'classroom', 'programme'],
    dropdown: true
  },
  {
    title: 'Skills',
    icon: defineAsyncComponent(
      () => import('~/components/common/icon/sidebar/IconSidebarBook.vue')
    ),
    link: '/skills/home',
    active: ['skills', 'interviews'],
    dropdown: true
  },
  jobLinkItem,
  forumLinkItem,
  eventsLinkItem
]

export const jobAdminNavbarLinks: SidebarItem[] = [
  jobLinkItem,
  //   forumLinkItem,
  eventsLinkItem
]

// WILL DELETE LATER
// just to remove unused var error
export const testingLinks = [forumLinkItem]
